import { render, staticRenderFns } from "./AdminProduct.vue?vue&type=template&id=cbb82fb6&"
import script from "./AdminProduct.vue?vue&type=script&lang=js&"
export * from "./AdminProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports